module.exports = __webpack_public_path__ + "public/images/tab-mobile.90b141175ba94198885bc74eb273fdc9.svg";